import React from "react"

function Footer() {

    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="copyright-box">
                            <p className="copyright">&copy; Copyright 2020 <strong>Shravani Allam Reddy</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;